import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ADMIN_PAGES_KEYS, NS, ORG_SETTINGS_KEYS } from '../../../../i18n/constants/keys';
import {
  BadgeCheckIcons,
  LayersIcons,
  UserSquareIcons,
} from '../../../../icons/icons';
import { FrameworkStatsHeaderProps } from '../interfaces';

export const FrameworkStatsHeader = ({
  skillsCount,
  subSkillsCount,
  jobTitlesCount,
}: FrameworkStatsHeaderProps) => {
  const { t } = useTranslation(NS.adminPages);

  return (
    <>
      <nav
          className='flex w-full justify-between items-center border-b py-3 text-sm'
          aria-label='Breadcrumb'
      >
        <ol className='inline-flex items-center space-x-1 md:space-x-2'>
          <li>
            <Link to={'#'} className='text-primary-textGray hover:underline'>
              {t(ORG_SETTINGS_KEYS.breadcrumbs.admin)}
            </Link>
          </li>
          <li>
            <span className='text-gray-400'>/</span>
          </li>
          <li>
            <Link
                to={'#'}
                className='text-primary-dark font-semibold hover:underline'
            >
              {t(ADMIN_PAGES_KEYS.assessmentFramework.title)}
            </Link>
          </li>
          <li>
            <span className='text-gray-400'>/</span>
          </li>
        </ol>
      </nav>

      <div className='flex justify-center items-center py-2'>
        <div className='flex items-center bg-white border border-gray-200/80 rounded-2xl shadow-xs divide-x divide-gray-200 overflow-hidden'>
          <div className='flex items-center gap-2 px-5 py-2.5'>
            <LayersIcons className='w-4 h-4 text-gray-500' />
            <span className='text-sm font-semibold text-gray-900 font-mono'>
              {skillsCount.toLocaleString()}
            </span>
            <span className='text-xs text-gray-500'>
              {t(ADMIN_PAGES_KEYS.assessmentFramework.skills)}
            </span>
          </div>

          <div className='flex items-center gap-2 px-5 py-2.5'>
            <BadgeCheckIcons className='w-4 h-4 text-gray-500' />
            <span className='text-sm font-semibold text-gray-900 font-mono'>
              {subSkillsCount.toLocaleString()}
            </span>
            <span className='text-xs text-gray-500'>
              {t(ADMIN_PAGES_KEYS.assessmentFramework.subSkills)}
            </span>
          </div>

          <div className='flex items-center gap-2 px-5 py-2.5'>
            <UserSquareIcons className='w-4 h-4 text-gray-500' />
            <span className='text-sm font-semibold text-gray-900 font-mono'>
              {jobTitlesCount.toLocaleString()}
            </span>
            <span className='text-xs text-gray-500'>
              {t(ADMIN_PAGES_KEYS.assessmentFramework.jobTitles)}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
